import {
  AlertCircle,
  Briefcase,
  Building2,
  CalendarCheck2,
  CalendarClock,
  CalendarDays,
  CalendarRange,
  Car,
  CheckCircle2,
  CircleHelp,
  Coins,
  HeartHandshake,
  HelpCircle,
  Home,
  Key,
  MapPin,
  PiggyBank,
  ShieldCheck,
  Sparkles,
  Truck,
  User,
  Wallet,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

// =============================================================================
// Icon registry · JSON configs reference icons by string name; the renderer
// looks them up here. Centralized so we control which icons end up in the
// bundle (no dynamic-import-of-all-of-lucide).
//
// Add an entry when a new vertical's FormConfig needs an icon. The key is the
// name written in `iconName` inside a FormFieldOption.
// =============================================================================

export const formIconRegistry: Record<string, LucideIcon> = {
  // MCMV
  AlertCircle,
  Briefcase,
  Building2,
  CalendarCheck2,
  CalendarClock,
  CalendarDays,
  CalendarRange,
  CheckCircle2,
  CircleHelp,
  Coins,
  HeartHandshake,
  HelpCircle,
  Home,
  PiggyBank,
  Sparkles,
  Wallet,
  // Generic / multi-vertical
  User,
  Key,
  // Proteção veicular and beyond
  Car,
  Truck,
  ShieldCheck,
  MapPin,
  Wrench,
};

export type FormIconName = keyof typeof formIconRegistry;

export function getFormIcon(name: string | undefined): LucideIcon | undefined {
  if (!name) return undefined;
  return formIconRegistry[name];
}
